module.exports = __webpack_public_path__ + "assets/3381c8a0df8b36b9168f331ebe8b43b0.json";